import { Shield, CheckCircle, Award, Lock, Users, BookCheck } from "lucide-react";
import { FACHKRAEFTE_KURZ, SEIT_TEXT, gross } from "@/config/webseiteFakten";

const badges = [
  {
    icon: Award,
    // Staatlich zugelassen ist nur Fachkraft für Musik (ZFU), deshalb kein „staatlich anerkannt“ für alle.
    title: gross(SEIT_TEXT),
    description: "Musikpädagogik aus der Praxis",
  },
  {
    icon: Shield,
    title: "Datenschutz-konform",
    description: "DSGVO-konforme Plattform",
  },
  {
    icon: CheckCircle,
    title: "Qualitätsgeprüft",
    description: "Professionelle Inhalte",
  },
  {
    icon: Lock,
    title: "Sichere Bezahlung",
    description: "SSL-verschlüsselt",
  },
  {
    icon: Users,
    title: `${FACHKRAEFTE_KURZ} Fachkräfte`,
    description: "Lernen mit MusiKonzept",
  },
  {
    icon: BookCheck,
    title: "Praxiserprobt",
    description: "Aus der Kita-Praxis",
  },
];

const TrustBadgesSection = () => {
  return (
    <section className="py-12 relative overflow-hidden border-y border-border/30">
      {/* Subtle Background */}
      <div className="absolute inset-0 bg-muted/30" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-6 max-w-6xl mx-auto">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center space-y-2 p-4 rounded-xl bg-background/50 backdrop-blur-sm border border-border/50 hover:border-primary/30 hover:bg-background/80 transition-all duration-300 animate-fade-in group"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              {/* Icon */}
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 group-hover:scale-110 transition-all duration-300">
                <badge.icon className="w-5 h-5 text-primary" />
              </div>

              {/* Title */}
              <p className="text-xs font-semibold text-foreground leading-tight">
                {badge.title}
              </p>

              {/* Description */}
              <p className="text-[10px] text-muted-foreground leading-tight">
                {badge.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadgesSection;
